/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown>, date: NonNullable<unknown> }} Seat_Change_Success_ScheduledInputs */



/**
* | output |
* | --- |
* | "Scheduled – the seat becomes {type} on {date}." |
*
* @param {Seat_Change_Success_ScheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_success_scheduled = /** @type {((inputs: Seat_Change_Success_ScheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Success_ScheduledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Geplant – der Platz wird am ${i?.date} zu einem ${i?.type}-Platz.`)
	return /** @type {LocalizedString} */ (`Scheduled – the seat becomes ${i?.type} on ${i?.date}.`)
});